import TabBadge from './TabBadge';

export default TabBadge;
